import { jsx as _jsx } from "react/jsx-runtime";
import React from 'react';
export const Checkbox = React.forwardRef(({ className = '', ...props }, ref) => {
    return (_jsx("input", { ref: ref, type: "checkbox", className: `h-4 w-4 rounded border-gray-300 text-blue-600 focus:ring-blue-400 cursor-pointer ${className}`, ...props }));
});
Checkbox.displayName = 'Checkbox';
